import { useMemo } from 'react';
import type { ChatMessage } from '../../../types';

interface UseThreadDataProps {
  messages: ChatMessage[];
  institutionName: string;
  institutionId?: number;
  messageSubject: string;
  unreadCount: number;
}

export function useThreadData({
  messages,
  institutionName,
  institutionId,
  messageSubject,
  unreadCount
}: UseThreadDataProps) {
  const thread = useMemo(() => {
    if (messages.length === 0) return null;
    const lastMessage = messages[messages.length - 1];

    return {
      id: 'single-thread',
      subject: messageSubject || `Correspondence with ${institutionName}`,
      institution: { id: institutionId || 1, name: institutionName },
      lastMessage: {
        content: lastMessage.content,
        timestamp: lastMessage.timestamp,
        sender: lastMessage.sender,
        direction: lastMessage.direction
      },
      messages,
      participants: [],
      unreadCount,
      status: 'received' as const,
      hasAttachments: messages.some(
        (m) => m.attachments && m.attachments.length > 0
      ),
      hasDraft: false,
      needsFollowUp: false,
      type: 'notification' as const
    };
  }, [messages, institutionName, institutionId, messageSubject, unreadCount]);

  return thread;
}
